import React from 'react';
import { ApolloProvider } from '@material-bank/apollo-client';
import { CustomerProvider } from '@material-bank/customer';
import {
  CurrentProjectStateBridge,
  ProjectsCustomerProvider,
} from '@material-bank/projects-utils';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { Provider } from 'react-redux';
import { ThemeContainer } from 'ui-widgets';

import { ProjectSelectionDialog } from './components/ProjectSelectionDialog';
import { Snackbar } from './components/Snackbar';
import { store } from './redux/store';

export const App = () => {
  return (
    <IntlProvider>
      <ApolloProvider>
        <ProjectsCustomerProvider>
          <CurrentProjectStateBridge source="project-selection-dialog" />
          <CustomerProvider>
            <Provider store={store}>
              <ThemeContainer>
                <ProjectSelectionDialog />
                <Snackbar />
              </ThemeContainer>
            </Provider>
          </CustomerProvider>
        </ProjectsCustomerProvider>
      </ApolloProvider>
    </IntlProvider>
  );
};
